import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

import Dropdown       from 'app/components/common/dropdown';
import Icon           from 'app/components/common/icon';
import StandardSelect from 'app/components/common/standard-select';
import format         from 'app/helpers/format';
import CadminSlx      from 'app/selectors/company-admin/';



/*
 * <CattrInput />
 */

class CattrInput extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }

  get options() {
    const cattrs = this.props.cattrSet?.cattrs || [];
    return cattrs.map((cattr) => {
      return {label: cattr.name, value: cattr.id};
    });
  }

  onSelect(cattrId) {
    this.props.onSelect(cattrId);
  }

  render() {
    return (
      <StandardSelect options={this.options} onSelect={this.onSelect} />
    );
  }

}

CattrInput.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({
  cattrSet: CadminSlx.cattrSet(state),
});

const ConnectedCattrInput = connect(stateToProps)(CattrInput);



/*
 * <CattrInput.Option />
 */

class CattrOptionInput extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }

  get options() {
    const cattrOpts = this.props.cattr?.options || [];
    const opts = [];
    cattrOpts.forEach((opt) => {
      opts.push({label: opt.name, value: opt.id});
    });
    opts.push({type: 'hr'});
    opts.push({label: 'Any Value', value: '*'});
    opts.push({label: 'Absent/Empty', value: 'null'});
    return opts;
  }

  onSelect(optId) {
    this.props.onSelect(optId);
  }

  render() {
    return (
      <StandardSelect options={this.options} onSelect={this.onSelect} value={this.props.value} allowClear />
    );
  }

}

CattrOptionInput.propTypes = {
  onSelect: PropTypes.func.isRequired,
  cattr: PropTypes.object.isRequired,
  value: PropTypes.string,
};

const stateToProps2 = (state) => ({
  cattrSet: CadminSlx.cattrSet(state),
});

const ConnectedCattrOptionInput = connect(stateToProps2)(CattrOptionInput);

ConnectedCattrInput.Option = ConnectedCattrOptionInput;



/*
 * <CattrInput.Pair />
 * Input that selects both an attribute and an attribution option.
 */

class CattrInputPair extends React.PureComponent {

  constructor(props) {
    super(props);

    this.refDropdown = React.createRef();

    this.state = {
      selectedCattrId: null,
    };

    this.onOpen = this.onOpen.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onClickCattrs = this.onClickCattrs.bind(this);
  }

  get cattrs() {
    return this.props.cattrSet?.cattrs || [];
  }

  get selectedCattr() {
    const {selectedCattrId} = this.state;
    if (!selectedCattrId) return null;
    return this.cattrs.find(c => c.id === selectedCattrId) || null;
  }

  get options() {
    return this.selectedCattr?.options || [];
  }

  get currentVal() {
    if (!this.props.optionId) return {};
    let option;
    const cattr = this.cattrs.find((c) => {
      option = c.options.find(o => o.id === this.props.optionId) || null;
      return option;
    }) || null;
    return {cattr, option};
  }

  onClickCattrs() {
    this.setState({selectedCattrId: null});
  }

  onClickCattr(cattr) {
    this.setState({selectedCattrId: cattr.id});
  }

  onClickOption(option) {
    const cattr = this.selectedCattr;
    this.props.onChange({cattr, option});
    this.refDropdown.current?.close();
  }

  onOpen() {
  }
  onClose() {
  }

  onClear() {
    this.props.onChange({});
    this.setState({selectedCattrId: null});
  }

  renderButton() {
    const {cattr, option} = this.currentVal;
    if (!option) return (
      <div className="nteepick-btn">
        <span className="nteepick-btn-placeholder">{this.props.label}</span>
      </div>
    );
    return (
      <div className="nteepick-btn labels">
        <div className="nteepick-btn-label1">{option.name}</div>
        <div className="nteepick-btn-label2">
          <span>{`${option.employeeCount} ${format.pluralize('employee', option.employeeCount)}`}</span>
          <span>{cattr.name}</span>
        </div>
      </div>
    );
  }

  renderMenu() {
    const columnClass = this.selectedCattr ? 'minors' : 'majors';

    return (
      <div className={`nteepick-menu ${columnClass}`}>
        <div className="nteepick-menu-columns">
          <div className="nteepick-menu-majors">
            <div className="nteepick-menu-heading">Custom Attributes</div>
            {this.cattrs.map((cattr) => {
              return (
                <button className="nteepick-menu-code" onClick={this.onClickCattr.bind(this, cattr)} key={cattr.id}>{cattr.name}</button>
              );
            })}
          </div>
          <div className="nteepick-menu-minors">
            <div className="nteepick-menu-heading">
              <button onClick={this.onClickCattrs} className="nteepick-menu-heading-back"><Icon.Caret direction="left" />attributes</button>
              <div>{this.selectedCattr?.name}</div>
            </div>
            {this.options.map((option) => {
              return (
                <button key={option.id} className="nteepick-menu-code minor" onClick={this.onClickOption.bind(this, option)}>{option.name}</button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {allowClear, className, name, validations} = this.props;
    const showClear = allowClear && !!this.currentVal?.option;
    const validationMessage = ((validations || {})[name || ''] || [])[0];
    return (
      <Dropdown
        className={`${className} cattr-input-pair`}
        ref={this.refDropdown}
        button={this.renderButton()}
        menu={this.renderMenu()}
        onOpen={this.onOpen}
        onClose={this.onClose}
        validationMessage={validationMessage}
        onClear={showClear ? this.onClear : undefined}
      />
    );
  }

}

CattrInputPair.propTypes = {
  onChange: PropTypes.func.isRequired,
  optionId: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  allowClear: PropTypes.bool,
  name: PropTypes.string,
  validations: PropTypes.object,
};

CattrInputPair.defaultProps = {
  className: '',
  label: 'Select a Custom Attribute',
  allowClear: true,
};

const stateToProps3 = (state) => ({
  cattrSet: CadminSlx.cattrSet(state),
});

ConnectedCattrInput.Pair = connect(stateToProps3)(CattrInputPair);



export default ConnectedCattrInput;
